import axios from 'axios';
import { QueryClient } from '@tanstack/react-query';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';

const apiHost = window.location.host.includes('localhost')
  ? '//danel-feinkost.local/api'
  : '/api';

// Create a function to get the query client instance
let queryClient: QueryClient | null = null;
export const setQueryClient = (client: QueryClient) => {
  queryClient = client;
};

const http = axios.create({
  baseURL: apiHost,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Change request data/error here
http.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error),
);

// Add response interceptor to handle unauthorized responses
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && queryClient) {
      // Clear user data from cache when unauthorized
      queryClient.setQueryData([API_ENDPOINTS.USERS, 'profile'], null);
    }
    return Promise.reject(error);
  },
);

export default http;
